import "../EasyProjectsCommon/EntitiesMetadata";

ep.metadataHelper = ep.metadataHelper || {};
export function calculateMaxLength(maxLength) {
    var reserveLength = 4; //4 - because the names generator adds space and (#) if there are similar names
    return maxLength - reserveLength;
}

ep.metadataHelper.calculateMaxLength = calculateMaxLength;

//note: 4000 is limit for nvarchar(max) param in query. 
//      And additional two chars for wrapping value with %val% for "contains" search
//      And because we escape % ('test%test' -> 'test~%test'), so result limit
//      is (4000 - 2) / 2 
export const maxSqlQueryParamLength = 1999;
ep.common.entitiesMetadata.maxSqlQueryParamLength = maxSqlQueryParamLength;

ep.common.entitiesMetadata.dayScheduleMaxValue = ep.common.entitiesMetadata.UserSchedule.MondayHoursMaxValue;
